
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.75 6a1 1 0 011-1h20a1 1 0 011 1v12a1 1 0 01-1 1h-20a1 1 0 01-1-1V6zm2 1v10h18V7h-18z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.75 6a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1 5 5 0 01-5-5zm2.172 1a2.999 2.999 0 001.828 1.828V7h-1.828zM21.75 15.172A2.999 2.999 0 0019.922 17h1.828v-1.828zm-2.535-.708A5 5 0 0122.75 13a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1 5 5 0 011.465-3.536zM1.75 14a1 1 0 011-1 5 5 0 015 5 1 1 0 01-1 1h-4a1 1 0 01-1-1v-4zm2 1.172V17h1.828a3 3 0 00-1.828-1.828zM2.043 5.293A1 1 0 012.75 5h4a1 1 0 011 1 5 5 0 01-5 5 1 1 0 01-1-1V6a1 1 0 01.293-.707zM3.75 7v1.828A3 3 0 005.578 7H3.75zM9.75 10.75c0-1.302 1.106-2.25 2.333-2.25h2.741a1 1 0 110 2h-2.74c-.246 0-.334.172-.334.25 0 .078.088.25.333.25h1.778c1.227 0 2.333.947 2.333 2.25s-1.106 2.25-2.333 2.25H10.75a1 1 0 110-2h3.111c.246 0 .333-.172.333-.25 0-.078-.087-.25-.333-.25h-1.778c-1.227 0-2.333-.947-2.333-2.25z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.75 7.5a1 1 0 011 1v1.017a1 1 0 01-2 0V8.5a1 1 0 011-1zM12.75 13.5a1 1 0 011 1v1.017a1 1 0 11-2 0V14.5a1 1 0 011-1z"}})])
          )
        }
      }
    